import { gql } from '@apollo/client';
import { TaxProfileTemplateInfo } from '../fragments';

export default gql`
  query TaxProfileTemplates($state: String, $templateKey: String) {
    taxProfileTemplates(state: $state, templateKey: $templateKey) {
      ...TaxProfileTemplateInfo
    }
  }
  ${TaxProfileTemplateInfo}
`;
